import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { State, Action, StateContext } from '@ngxs/store';
import { lastValueFrom } from 'rxjs';
import { environment } from './environments/environment';

export class LoadHeaderData {
  static readonly type = '[GlobalData] Load Header';
  constructor() {}
}

export class LoadFooterData {
  static readonly type = '[GlobalData] Load Footer';
  constructor() {}
}

export class LoadSponsors {
  static readonly type = '[GlobalData] Load Sponsors';
  constructor() {}
}

export class LoadLanguages {
  static readonly type = '[GlobalData] Load Languages';
  constructor() {}
}

export interface GlobalDataStateModel {
  header: any;
  footer: any;
  sponsors: any;
  languages: any;
}

@State<GlobalDataStateModel>({
  name: 'globalData',
  defaults: {
    header: null,
    footer: null,
    sponsors: null,
    languages: null,
  },
})
@Injectable()
export class ApplicationState {
  private http = inject(HttpClient);
  private readonly apiUrl = environment.strapiApiUrl.replace(/\/+$/, '');

  @Action(LoadHeaderData)
  async loadHeaderData(
    ctx: StateContext<GlobalDataStateModel>,
    action: LoadHeaderData
  ) {
    try {
      const res = await lastValueFrom<any>(
        this.http.get(`${this.apiUrl}/global`)
      );

      ctx.patchState({ header: res?.data?.header });
    } catch (err) {
      console.error('Error fetching header data', err);
    }
  }

  @Action(LoadFooterData)
  async loadFooterData(
    ctx: StateContext<GlobalDataStateModel>,
    action: LoadFooterData
  ) {
    try {
      const res = await lastValueFrom<any>(
        this.http.get(`${this.apiUrl}/global`)
      );

      ctx.patchState({ footer: res?.data?.footer });
    } catch (err) {
      console.error('Error fetching footer data', err);
    }
  }

  @Action(LoadSponsors)
  async loadSponsors(
    ctx: StateContext<GlobalDataStateModel>,
    action: LoadSponsors
  ) {
    try {
      const res = await lastValueFrom<any>(
        this.http.get(`${this.apiUrl}/sponsor`)
      );

      ctx.patchState({ sponsors: res?.data?.sponsors });
    } catch (err) {
      console.error('Error fetching sponsors data', err);
    }
  }

  @Action(LoadLanguages)
  async loadLanguages(
    ctx: StateContext<GlobalDataStateModel>,
    action: LoadLanguages
  ) {
    try {
      const res = await lastValueFrom<any>(
        this.http.get(`${this.apiUrl}/i18n/locales`)
      );

      ctx.patchState({ languages: res });
    } catch (err) {
      console.error('Error fetching languages data', err);
    }
  }
}